import { IComponentOptions, IController } from "angular";
import { take } from "rxjs";
import { BadgesModalsService } from "@gtmhub/badges/services/badgesModals";
import { IGtmhubRootScopeService } from "@gtmhub/models";
import { NewHomeExperienceService } from "@webapp/home/services/new-home-experience.service";

class BadgesTopNavBarCtrl implements IController {
  public hasPermission: (action: string) => boolean;
  public featureAvailable: (name: string) => boolean;
  public openAwardDialog: () => void;
  public isNextTopNavBarEnabled: boolean;

  static $inject = ["$rootScope", "BadgesModalsService", "NewHomeExperienceService"];

  constructor($rootScope: IGtmhubRootScopeService, badgesModalsService: BadgesModalsService, private newHomeExperienceService: NewHomeExperienceService) {
    this.hasPermission = $rootScope.hasPermission.bind($rootScope);
    this.featureAvailable = $rootScope.featureAvailable.bind($rootScope);
    this.openAwardDialog = () => badgesModalsService.openAwardDialog({});

    this.newHomeExperienceService
      .isNewNavigationEnabled$()
      .pipe(take(1))
      .subscribe((isFeatureAvailable) => {
        this.isNextTopNavBarEnabled = isFeatureAvailable;
      });
  }
}

export const BadgesTopNavBarComponent: IComponentOptions = {
  controller: BadgesTopNavBarCtrl,
  template: require("./badges-top-nav-bar.component.html"),
};
